import Layout from "./authentication/Layout";
// import PageNotFound from "./components/commonComponents/PageNotFound";
import { NotifContextProvider } from "./components/dashboard/components/notifications/context/notifContext";
import DynamicPunojsitView from "./components/punonjesit/DynamicView/DynamicPunojsitView";
import ListPrezenca from "./components/ListPrezenca/ListPrezenca";
import Raportet from "./components/Raportet/Raportet";
import DocumentationConfiguration from "./components/DocumentationConfiguration/DocumentationConfiguration";
import {
  Kofigurimet,
  PerdoruesitTeDhenatAksesit,
  MenyratPageses,
  FestatZyrtare,
  PolitikatDitetPushim,
  PolitikatOretJashtOrarit,
  SistemiStatustetPunojsve,
  SistemiLlojetKerkesave,
  SistemiDokumentacionet,
  SistemiPaisjetOrarit,
  InformacioneRrethKompanis,
  SistemiArsyetLargimeve,
  SiguriaFiltrartPerdoruesve,
  PagatFitimetSetigns,
  UserProfile,
  SistemiTurnet,
  SiguriaPerdoruesit,
  PagatZbritjetSetings,
  KonfigurimetPozicionet,
  Preferencat,
  KonfigurimiKandidateve,
  KompaniaRolet,
} from "./components/Konfigurimet/index";
import DashboardBase from "./components/dashboard/DashboardBase";
import Approvals from "./components/Pagat/approvals/Approvals";
import Wages from "./components/Pagat/wages/Wages";
import Departamentet from "./Departments/Department";
import DocumentationPage from "./components/Documentation/DocumentationPage";
import PagatEksportetListes from "./components/Konfigurimet/PagatSettings/PagatEksportetListes/PagatEksportetListes";
import PagatGrid from "./components/Pagat/PagatGrid";
import MainWage from "./components/Pagat/wages/MainWage";
import ReportsMain from "./components/Reports/ReportsMain";
import GeneratePage from "./components/Reports/generate/GeneratePage";
import Announcements from "./components/Announcement/Announcements";
import Intervistat from "./components/Intervistat/Intervistat";
import SistemiIP from "./components/Konfigurimet/SistemiSettings/SistemiIp/SistemiIP";
import ProblematikatPage from "./components/Problematikat/ProblematikatPage";
import EmailTemplate from "./components/Konfigurimet/EmailTemplate/EmailTemplate";

// import Punonjesit from "./components/punonjesit/Punonjesit";
import Punonjesit from "./components/punonjesit/Punonjesit.jsx";
import NotFound from "./components/commonComponents/NotFound/NotFound.jsx";

export const AuthRouteData = [
  {
    path: "/",
    Component: DashboardBase,
    View: Layout,
    Context: NotifContextProvider,
  },
  {
    path: "/kryefaqja",
    Component: DashboardBase,
    View: Layout,
  },
  {
    path: "/punonjesit",
    Component: Punonjesit,
    View: Layout,
  },
  {
    path: "/punonjesit/specifikat/:employeeId",
    Component: DynamicPunojsitView,
    View: Layout,
  },
  {
    path: "/prezencat",
    Component: ListPrezenca,
    View: Layout,
  },
  {
    path: "/pagat",
    Component: MainWage,
    View: Layout,
  },
  {
    path: "/pagat/llogaritja",
    Component: Wages,
    View: Layout,
  },

  {
    path: "/aprovimet",
    Component: Approvals,
    View: Layout,
  },
  {
    path: "/dokumentacione",
    Component: DocumentationPage,
    View: Layout,
  },
  {
    path: "/raportet",
    Component: ReportsMain,
    View: Layout,
  },
  {
    path: "/raportet/gjenero/:reportType",
    Component: GeneratePage,
    View: Layout,
  },
  {
    path: "/departamentet",
    Component: Departamentet,
    View: Layout,
  },
  {
    path: "/lajmerimet",
    Component: Announcements,
    View: Layout,
  },
  {
    path: "konfigurimet",
    Component: Kofigurimet,
    View: Layout,
    child: [
      {
        path: "kompania/profili",
        Component: UserProfile,
      },
      {
        path: "kompania/info/rreth/komapnise",
        Component: InformacioneRrethKompanis,
      },
      {
        path: "kompania/pozicionet",
        Component: KonfigurimetPozicionet,
      },
      {
        path: "kompania/rolet/:departmentId",
        Component: KompaniaRolet,
      },
      {
        path: "sistemi/pajisjet/orarit",
        Component: SistemiPaisjetOrarit,
      },
      {
        path: "sistemi/turnet",
        Component: SistemiTurnet,
      },
      // {
      // 	path: "sistemi/turnet",
      // 	Component: SistemiTurnet,
      // },
      {
        path: "sistemi/statuset/punojesve",
        Component: SistemiStatustetPunojsve,
      },
      {
        path: "sistemi/arsyet/largimit",
        Component: SistemiArsyetLargimeve,
      },
      {
        path: "sistemi/llojet/kerkesave",
        Component: SistemiLlojetKerkesave,
      },
      {
        path: "sistemi/dokumentacionet",
        Component: SistemiDokumentacionet,
      },
      { path: "sistemi/adresatIp", Component: SistemiIP },
      {
        path: "politikat/ditet/pushimit",
        Component: PolitikatDitetPushim,
      },
      {
        path: "politikat/festave/zyrtare",
        Component: FestatZyrtare,
      },
      {
        path: "politikat/oreve/jashte/orarit",
        Component: PolitikatOretJashtOrarit,
      },
      {
        path: "pagat/fitimet",
        Component: PagatFitimetSetigns,
      },
      {
        path: "pagat/zbritje",
        Component: PagatZbritjetSetings,
      },
      {
        path: "pagat/pagesat",
        Component: MenyratPageses,
      },
      {
        path: "pagat/kalkulimi",
        Component: PagatEksportetListes,
      },
      {
        path: "perdoruesit",
        Component: SiguriaPerdoruesit,
      },
      {
        path: "konfigurimet/preferencat",
        Component: Preferencat,
      },
      {
        path: "siguria/filtrat/perdorusve",
        Component: SiguriaFiltrartPerdoruesve,
      },
      { path: "preferencat", Component: Preferencat },
      {
        path: "konfigurimiKandidateve",
        Component: KonfigurimiKandidateve,
      },
      {
        path: "perdoruesit/:identityId",
        Component: PerdoruesitTeDhenatAksesit,
      },
      {
        path: "dokumentacione",
        Component: DocumentationConfiguration,
      },
      { path: "preferencat", Component: SiguriaFiltrartPerdoruesve },
      {
        path: "emailTemplate",
        Component: EmailTemplate,
      },
    ],
  },
  {
    path: "/intervistat",
    Component: Intervistat,
    View: Layout,
  },
  {
    path: "/problematikat",
    Component: ProblematikatPage,
    View: Layout,
  },
  {
    path: "*",
    Component: NotFound,
    View: Layout,
  },
];
